import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select-legacy';
import { isEmpty, join, trim } from 'lodash';
import { formatMapIds, formatMapNames } from 'utils/Formatters';

export default class AccountDetails extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    editable: PropTypes.bool.isRequired,
    groups: PropTypes.arrayOf(PropTypes.object).isRequired,
    onUpdate: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isEdit: false, ...this.initialState() };
  }

  initialState() {
    const { firstName, lastName, email, phone, groups } = this.props.account;
    return { firstName, lastName, email, phone, groupIds: formatMapIds(groups) };
  }

  onCancel = () => {
    this.setState({ isEdit: false });
  }

  onChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({[name]: value});
  }

  onGroupChange = (groupIds) => {
    this.setState({ groupIds });
  }

  onEdit = () => {
    this.setState({ isEdit: true, ...this.initialState() });
  }

  onUpdate = () => {
    const { account } = this.props;
    const { firstName, lastName, email, phone, groupIds } = this.state;
    this.setState({ isEdit: false });
    this.props.onUpdate(account.id, { firstName, lastName, email, phone, groupIds });
  }

  render() {
    const { isEdit, firstName, lastName, email, phone, groupIds } = this.state;
    const { account, editable, groups } = this.props;
    const clsUpdate = classNames('o-sp-button o-sp-button--update o-sp-button--primary',
      { 'u-disabled': isEmpty(trim(firstName)) || isEmpty(trim(lastName)) || isEmpty(trim(email)) || isEmpty(trim(groupIds)) }
    );
    return (
      <section className='column o-card cs-bg--light'>
        { !isEdit && editable && <a className='cs-txt-link--sp-blue u-float--right' onClick={this.onEdit}>EDIT</a>}
        { isEdit &&
          <p>
            <span className='u-txt--label'>First Name</span><br/>
            <input name='firstName' type='text' value={firstName} onChange={this.onChange}/>
          </p> }
        { isEdit &&
          <p>
            <span className='u-txt--label'>Last Name</span><br/>
            <input name='lastName' type='text' value={lastName} onChange={this.onChange}/>
          </p> }
        <p>
          <span className='u-txt--label'>Email</span><br/>
          { isEdit ? <input name='email' type='text' value={email} onChange={this.onChange}/> : account.email }
        </p>
        <p>
          <span className='u-txt--label'>Phone</span><br />
          {isEdit ? <input name='phone' type='text' value={phone} onChange={this.onChange} /> : account.phone}
        </p>
        <p>
          <span className='u-txt--label'>ZIP Code</span><br />
          {isEdit ? <input name='zip' type='text' value={account.zip} readOnly disabled /> : account.zip}
        </p>
        <p>
          <span className='u-txt--label'>Address</span><br />
          {isEdit ? <input name='address' type='text' value={account.address} readOnly disabled /> : account.address}
        </p>
        <div className='u-margin-bottom--base'>
          <span className='u-txt--label'>Group</span><br/>
          { isEdit ?
            <Select
              name='sp-group-select'
              className={'o-select o-select--optgroup'}
              value={groupIds || ''}
              onChange={this.onGroupChange}
              options={groups}
              placeholder='Select Group'
              simpleValue={true} /> : formatMapNames(account.groups) }
        </div>
        <p>
          <span className='u-txt--label'>Cohorts</span><br/>
          { join(account.cohorts, ', ') }
        </p>
        <p>
          <span className='u-txt--label'>Status</span><br/>
          { account.archived ? 'Archived' : 'Active' }
        </p>
        { isEdit &&
          <div className='row align-middle'>
            <div className='column shrink'>
              <a className={clsUpdate} onClick={this.onUpdate}>Update</a>
            </div>
            <div className='column shrink'>
              <a className='o-sp-button--update cs-txt-link--sp-blue' onClick={this.onCancel}>Cancel</a>
            </div>
          </div> }
      </section>
    )
  }
}
